module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/043-montserrat-5d65d60ff52ee9c0ab56463b3028be3a.svg";